import React, { useEffect } from "react";
import { Typography, Form, Alert } from "antd";
import CustomButton from '../../../components/CustomButton/Button';
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import { editBusDets, getBusinessDetailedView, getAllDesignations, clearProfileError } from "../../../redux/slices/BusinessProfileSlice";
import { getDropdownData } from "../../../redux/slices/BusinessProfileSlice";
import { capitalizeWords } from "../../../helpers/helpers";
import { BTN_TXT, ERROR_MSGS, GLOBAL_CONSTANTS } from "../../../constants/constants";

const { Title } = Typography;

const EditDropdownsForm = ({
    setEditDropdownsModalOpen,
    isDesignation,
    designation,
    isIndustry,
    industry,
    isAnnualTurnover,
    annualTurnover,
    setIsIndustryType,
    setIsAnnualTurnover,
    company,
    isCompanyType,
    setIsCompanyType,
    isMultipleGstin,
    setIsMultipleGstin,
    hasMultipleGstin
}) => {
    const dispatch = useDispatch();
    const { editDetailError, editDetailLoading, designations } = useSelector((state) => state.profile1);
    const { dropdownData } = useSelector((state) => state.profile1);
    const { user } = useSelector((state) => state.auth);
    const [form] = Form.useForm();

    const multipleGstinOptions = [
        { label: "YES", value: true },
        { label: "NO", value: false },
    ]

    useEffect(() => {
        if (isDesignation) {
            dispatch(getAllDesignations());
        } else if (isIndustry || isAnnualTurnover || isCompanyType) {
            dispatch(getDropdownData());
        }
        return () => {
            dispatch(clearProfileError());
        };
    }, [dispatch, isDesignation, isIndustry, isAnnualTurnover, isCompanyType]);

    const handleOnFinish = async (values) => {
        let payload = {}
        if (isDesignation) {
            payload.designationId = values.designation
        } else if (isIndustry) {
            payload.industryTypeId = values.industryType
        } else if (isAnnualTurnover) {
            payload.annualTurnoverId = values.annualTurnover
        } else {
            payload.hasMultipleGstin = values.hasMultipleGstin
        }

        const res = await dispatch(editBusDets(payload));

        if (res.payload.statusCode === 201) {
            setEditDropdownsModalOpen(false);

            if (isIndustry) {
                setIsIndustryType(false);
            } else if (isAnnualTurnover) {
                setIsAnnualTurnover(false);
            } else if (isCompanyType) {
                setIsCompanyType(false);
            } else if (isMultipleGstin) {
                setIsMultipleGstin(false);
            }

            // ✅ Immediately fetch the updated business profile
            dispatch(getBusinessDetailedView(user.orgId));
        }
    };


    const getTitle = () => {
        if (isDesignation) return GLOBAL_CONSTANTS.DESIG;
        if (isIndustry) return GLOBAL_CONSTANTS.IND_TYPE;
        if (isAnnualTurnover) return GLOBAL_CONSTANTS.ANN_TURN;
        if (isCompanyType) return GLOBAL_CONSTANTS.COMP_TYPE;
        return "";
    };

    return (
        <>
            <Title level={4}>Edit {getTitle()}</Title>
            <Form
                form={form}
                layout="vertical"
                className="com-address-form"
                onFinish={handleOnFinish}
                initialValues={{
                    remember: true,
                    designation: designation || null,
                    industryType: industry || null,
                    annualTurnover: annualTurnover || null,
                    companyType: company || null,
                    hasMultipleGstin: hasMultipleGstin
                }}
            >
                {isDesignation && (
                    <CustomSelect
                        label="Designation (choose 'Other' if not listed)"
                        name="designation"
                        showSearch
                        placeholder="Select Designation"
                        className="custom-edit-dropdowns-select"
                        options={designations.map((designation) => ({
                            value: designation.designationId,
                            label: capitalizeWords(designation.designationName)
                        }))}
                        rules={[{ required: true, message: ERROR_MSGS.DESIGNATION_ERR_MEG }]}
                    />
                )}

                {isIndustry && (
                    <CustomSelect
                        label="Industry Type"
                        name="industryType"
                        showSearch
                        placeholder="Select Industry Type"
                        className="custom-edit-dropdowns-select"
                        options={dropdownData?.industryTypeList?.map((industry) => ({
                            value: industry.industryTypeId,
                            label: capitalizeWords(industry.industryTypeName)
                        }))
                        }
                        rules={[{ required: true, message: ERROR_MSGS.SEL_IND_TYPE }]}
                    />
                )}

                {isAnnualTurnover && (
                    <CustomSelect
                        label="Annual Turnover"
                        name="annualTurnover"
                        placeholder="Select Annual Turnover"
                        className="custom-edit-dropdowns-select"
                        options={dropdownData?.annualTurnoverList?.map((annualTurnover) => ({
                            value: annualTurnover.annualTurnoverId,
                            label: capitalizeWords(annualTurnover.annualTurnoverName)
                        }))
                        }
                        rules={[{ required: true, message: ERROR_MSGS.SEL_ANN_TURN }]}
                    />
                )}

                {isCompanyType && (
                    <CustomSelect
                        label="Company Type"
                        name="companyType"
                        placeholder="Select Company Type"
                        className="custom-edit-dropdowns-select"
                        options={dropdownData?.businessTypeList?.map((businessType) => ({
                            value: businessType.businessTypeId,
                            label: capitalizeWords(businessType.businessTypeName)
                        }))
                        }
                        rules={[{ required: true, message: ERROR_MSGS.SEL_COMP_TYPE }]}
                    />
                )}

                {isMultipleGstin && (
                    <CustomSelect
                        label="Has Multiple GSTIN"
                        name="hasMultipleGstin"
                        placeholder="Select Has multiple gstin"
                        className="custom-edit-dropdowns-select"
                        options={multipleGstinOptions?.map((Gstin) => ({
                            value: Gstin.value,
                            label: capitalizeWords(Gstin.label)
                        }))
                        }
                        rules={[{ required: true, message: ERROR_MSGS.SEL_COMP_TYPE }]}
                    />
                )}

                {editDetailError && <Alert style={{ marginBottom: 20 }} message={editDetailError} type="error" showIcon />}

                <Form.Item>
                    <CustomButton type="primary" loading={editDetailLoading} htmlType="submit" block>
                        {BTN_TXT.SAVE}
                    </CustomButton>
                </Form.Item>
            </Form>
        </>
    )
}

export default EditDropdownsForm